import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { setup, renderScreens, screen } from './dooh-react-utils';
import preloader from './preload';
import questions from './questions';

//setup('/proxy/?url=https://interaktivno.go2digital.hr/').then(async data => {
setup('https://interaktivno.go2digital.hr/').then(async data => {
  const state = {
    screen: 'intro',
    loop: false,
    score: [0, 0, 0, 0],
    questions,
  };

  const store = await renderScreens(
    [
      screen(require('./screens/Intro').default, 'intro', {}),
      screen(require('./screens/Quiz').default, 'quiz', {
        timeout: 60 * 1000,
      }),
      screen(require('./screens/Thanks').default, 'thanks', {
        timeout: 10 * 1000,
      }),
    ],
    state,
    s => s.screen,
    preloader
  );

  const Style = createGlobalStyle`
    #root {
      font-family: 'RegularFont', sans-serif;
    }
  `;

  // preloader done, init questions
  store.update({
    style: <Style />,
  });
});
